export const DEFAULT_CARCASE_THICKNESS = 16.5;
